var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.31357 5.42552C5.15491 4.55014 6.29585 4.05838 7.4855 4.05838C8.67515 4.05838 9.81609 4.55014 10.6574 5.42552L11.972 6.7925L13.2865 5.42552C13.7003 4.97954 14.1954 4.62382 14.7428 4.3791C15.2901 4.13438 15.8788 4.00556 16.4746 4.00018C17.0703 3.99479 17.661 4.11293 18.2124 4.34772C18.7638 4.5825 19.2647 4.92922 19.6859 5.36765C20.1072 5.80607 20.4403 6.32742 20.6659 6.90128C20.8915 7.47514 21.005 8.09001 20.9998 8.71001C20.9947 9.33002 20.8709 9.94274 20.6358 10.5124C20.4006 11.0821 20.0588 11.5974 19.6303 12.0281L11.972 20L4.31357 12.0281C3.47249 11.1525 3 9.96498 3 8.72682C3 7.48865 3.47249 6.30117 4.31357 5.42552Z",
    fill: "#151C3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.0bb1c29ce961bfc62e6329fa704f0d8e.svg";
export { ForwardRef as ReactComponent };